"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inventoryColumns = void 0;
const utils_1 = require("../utils");
function inventoryColumns() {
    return [
        {
            field: 'botanisch',
            headerName: 'Botanisch',
            editable: false,
            type: 'derivedColumn',
        },
        {
            field: 'ean',
            headerName: 'EAN',
            editable: false,
            type: 'derivedColumn',
        },
        {
            field: 'tb',
            editable: false,
            headerName: 'Tb',
            type: 'derivedColumn',
        },
        {
            field: 'pg',
            editable: false,
            headerName: 'PG',
            type: 'derivedColumn',
        },
        {
            field: 'interne_art_nr',
            headerName: 'Interne Art.-Nr.',
            editable: false,
            type: 'derivedColumn',
        },
        {
            field: 'package_size',
            headerName: 'Verpkg.gr.',
            editable: false,
            type: 'derivedColumn',
        },
        {
            field: 'etikett',
            headerName: 'Etikett',
            editable: false,
            type: 'derivedColumn',
        },
        {
            field: 'quantity',
            editable: true,
            valueFormatter: utils_1.floatFormatter,
            headerName: 'Lagermenge',
        },
    ];
}
exports.inventoryColumns = inventoryColumns;
